import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { WarehouseMaterialStockAdapter } from '../adapters/WarehouseMaterialStockAdapter';

export function useWarehouseMaterialEmptyLocations(enabled: boolean) {
  return useQuery({
    queryKey: ['warehouse-material-empty-locations'],
    enabled,
    queryFn: async () => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new WarehouseMaterialStockAdapter(httpClient);
      return adapter.getEmptyWarehouseLocations();
    },
    staleTime: 60 * 1000,
  });
}
